import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MobileMenu from "./MobileMenu";
import LoginForm from "./LoginForm";

function HeaderOne() {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginFormOpen, setIsLoginFormOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      {/*============================== Header Area ==============================*/}
      <header className="th-header header-layout1">
        <div className="header-top">
          <div className="container th-container">
            <div className="row justify-content-center justify-content-xl-between align-items-center">
              <div className="col-auto d-none d-md-block">
                <div className="header-links">
                  <ul>
                    <li className="d-none d-xl-inline-block">
                      <i className="fa-sharp fa-regular  fa-location-dot" />
                      <span>Moi Avenue, Nairobi, Kenya</span>
                    </li>
                    <li className="d-none d-xl-inline-block">
                      <i className="fa-regular fa-clock" />
                      <span>Sun to Friday: 8.00 am - 7.00 pm</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-auto">
                <div className="header-right">
                  <div className="header-links">
                    <ul>
                      <li className="d-none d-md-inline-block">
                        <Link>FAQ</Link>
                      </li>
                      <li className="d-none d-md-inline-block">
                        <Link>Support</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`sticky-wrapper ${isSticky ? "sticky" : ""}`}>
          {/* Main Menu Area */}
          <div className="menu-area">
            <div className="container th-container">
              <div className="row align-items-center justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img src="/assets/img/logo.svg" alt="Tourm" />
                    </Link>
                  </div>
                </div>
                <div className="col-auto me-xl-auto">
                  <nav className="main-menu d-none d-xl-inline-block">
                    <ul>
                      <li>
                        <Link className="active">Home</Link>
                      </li>

                      {/* Destinations */}
                      <li className="menu-item-has-children">
                        <Link>Destinations</Link>
                        <ul className="sub-menu">
                          <li className="menu-item-has-children">
                            <Link>Top Countries</Link>
                            <ul className="sub-menu">
                              <li>
                                <Link>Tanzania</Link>
                              </li>
                              <li>
                                <Link>Kenya</Link>
                              </li>
                              <li>
                                <Link>Rwanda</Link>
                              </li>
                              <li>
                                <Link>South Africa</Link>
                              </li>
                              <li>
                                <Link>Botswana</Link>
                              </li>
                              <li>
                                <Link>Zimbabwe</Link>
                              </li>
                            </ul>
                          </li>

                          <li className="menu-item-has-children">
                            <Link>East Africa</Link>
                            <ul className="sub-menu">
                              <li>
                                <Link>Tanzania</Link>
                              </li>
                              <li>
                                <Link>Kenya</Link>
                              </li>
                              <li>
                                <Link>Uganda</Link>
                              </li>
                              <li>
                                <Link>Rwanda</Link>
                              </li>
                            </ul>
                          </li>

                          <li className="menu-item-has-children">
                            <Link>Southern Africa</Link>
                            <ul className="sub-menu">
                              <li>
                                <Link>Botswana</Link>
                              </li>
                              <li>
                                <Link>Namibia</Link>
                              </li>
                              <li>
                                <Link>Zambia</Link>
                              </li>
                              <li>
                                <Link>South Africa</Link>
                              </li>
                              <li>
                                <Link>Zimbabwe</Link>
                              </li>
                            </ul>
                          </li>

                          <li className="menu-item-has-children">
                            <Link>Island Escapes</Link>
                            <ul className="sub-menu">
                              <li>
                                <Link>Seychelles</Link>
                              </li>
                              <li>
                                <Link>Mauritius</Link>
                              </li>
                              <li>
                                <Link>Mozambique</Link>
                              </li>
                              <li>
                                <Link>Madagascar</Link>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <Link>All Destinations</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Safaris */}
                      <li className="menu-item-has-children">
                        <Link>Safaris</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link>Find Your Adventure</Link>
                          </li>
                          <li>
                            <Link>Best Time to Travel</Link>
                          </li>

                          <li className="menu-item-has-children">
                            <Link>Safari Experiences</Link>
                            <ul className="sub-menu">
                              <li>
                                <Link>Photography Safaris</Link>
                              </li>
                              <li>
                                <Link>Family Safaris</Link>
                              </li>
                              <li>
                                <Link>Romantic Escapes</Link>
                              </li>
                              <li>
                                <Link>Beach + Safari</Link>
                              </li>
                              <li>
                                <Link>Honeymoon Safaris</Link>
                              </li>
                              <li>
                                <Link>Cultural Journeys</Link>
                              </li>
                              <li>
                                <Link>Active Adventures</Link>
                              </li>
                              <li>
                                <Link>Last Minute Deals</Link>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <Link>Tailor-Made Trips</Link>
                          </li>
                          <li>
                            <Link>Group Departures</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Discover */}
                      <li className="menu-item-has-children">
                        <Link>Discover</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link>Travel Guides</Link>
                          </li>
                          <li>
                            <Link>Trip Reports</Link>
                          </li>
                          <li>
                            <Link>Photo Galleries</Link>
                          </li>
                          <li>
                            <Link>Videos</Link>
                          </li>

                          <li className="menu-item-has-children">
                            <Link>Parks & Regions</Link>
                            <ul className="sub-menu">
                              <li>
                                <Link>National Parks</Link>
                              </li>
                              <li>
                                <Link>Coastal Regions</Link>
                              </li>
                              <li>
                                <Link>Hidden Gems</Link>
                              </li>
                            </ul>
                          </li>

                          <li>
                            <Link>Stay Longer, Explore Deeper</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Planning */}
                      <li className="menu-item-has-children">
                        <Link>Planning</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link>Why Travel Africa?</Link>
                          </li>
                          <li>
                            <Link>FAQs</Link>
                          </li>
                          <li>
                            <Link>Travel Tips</Link>
                          </li>
                          <li>
                            <Link>Best Time To Visit</Link>
                          </li>
                          <li>
                            <Link>Request A Trip Plan</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Our Story */}
                      <li className="menu-item-has-children">
                        <Link>Our Story</Link>
                        <ul className="sub-menu">
                          <li>
                            <Link>Meet the Team</Link>
                          </li>
                          <li>
                            <Link>Meet the Guides</Link>
                          </li>
                          <li>
                            <Link>Our Impact</Link>
                          </li>
                          <li>
                            <Link>Awards & Press</Link>
                          </li>
                          <li>
                            <Link>Traveler Reviews</Link>
                          </li>
                          <li>
                            <Link>Why Choose Us?</Link>
                          </li>
                        </ul>
                      </li>

                      {/* Contact */}
                      <li>
                        <Link>Contact Us</Link>
                      </li>
                    </ul>
                  </nav>
                  <button
                    type="button"
                    className="th-menu-toggle d-block d-xl-none"
                    onClick={() => setIsMobileMenuOpen(true)}
                  >
                    <i className="far fa-bars" />
                  </button>
                </div>
                <div className="col-auto d-none d-xl-block">
                  <div className="header-button">
                    <Link className="th-btn style3 th-icon">Explore Now</Link>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="logo-bg bg-mask"
              style={{
                WebkitMaskImage: "url(/assets/img/logo_bg_mask.png)",
                maskImage: "url(/assets/img/logo_bg_mask.png)",
              }}
            />
          </div>
        </div>
      </header>
      <MobileMenu
        isOpen={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
      />
      <LoginForm
        isOpen={isLoginFormOpen}
        onClose={() => setIsLoginFormOpen(false)}
      />
    </>
  );
}

export default HeaderOne;
